import {useCallback, useMemo} from 'react';
import isEqual from 'lodash/isEqual';

import {DocumentInputField} from '@/engine';
import {useDocumentContext} from '../context/use-document-context';
import {FieldProps} from '../meta-field';
import {useFieldOptions} from './use-field-options';

export function useSelectProps({field, storedValue, handleChange, ...props}: FieldProps<DocumentInputField>) {
  const {valueResolver} = useDocumentContext();

  const options = useFieldOptions(field);

  const selectedOption = useMemo(() => {
    return options?.find(option => isEqual(valueResolver(option.raw), valueResolver(storedValue))) ?? null;
  }, [options, storedValue, valueResolver]);

  const onChange = useCallback(
    (value?: string) => {
      if (value == undefined) return;
      const selected = options?.find(option => option.value === value)?.raw ?? '';
      handleChange(selected, true);
    },
    [options, handleChange],
  );

  return {field, options, selectedOption, onChange, ...props};
}
